import type { PasswordResetRequestData } from '../api/useAuth'

/** Identity anti-enumeration: registered emails return a non-empty maskedEmail on HTTP 200. */
export function extractMaskedEmail(
  data: PasswordResetRequestData | null | undefined
): string | null | undefined {
  if (data == null) return undefined
  const record = data as Record<string, unknown>
  const raw = record.maskedEmail ?? record.masked_email
  if (raw === null) return null
  if (typeof raw === 'string') return raw
  return undefined
}

export function isRegisteredEmailResponse(
  maskedEmail: string | null | undefined
): boolean {
  return typeof maskedEmail === 'string' && maskedEmail.trim().length > 0
}
